import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-deactive-modal',
  templateUrl: './user-deactive-modal.component.html',
  styleUrls: ['./user-deactive-modal.component.css']
})
export class UserDeactiveModalComponent implements OnInit {
  @Input() public user: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {}

}
